import React from 'react'
import { initializeApollo } from '@gql/client'
import { PaginaDocument } from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import { AziendaDetailTemplate } from '@components/templates'

const AziendaDetail = ({ pagina, paginaAzienda }) => (
  <AziendaDetailTemplate pagina={pagina} paginaAzienda={paginaAzienda} />
)

export const getStaticPaths = NextWrapper.getStaticPaths(async ({ locales }) => {
  let paths = []

  // for (const locale of locales) {
  //   if (locale === 'default') continue

  //   const client = initializeApollo(locale)

  //   const {
  //     data: { pagina },
  //   } = await client.query({
  //     query: PaginaDocument,
  //     variables: { chiave: 'azienda', withMenuChildren: true },
  //   })
  //   if (pagina?.children && pagina.children.length > 0) {
  //     pagina?.children
  //       ?.filter((x) => x.chiave !== "tecnologie" && x.chiave !== "tecnologia-detail")
  //       .forEach((x) => paths.push({ params: { slug: x.slug }, locale }))
  //   }
  // }

  return {
    paths: paths,
    fallback: 'blocking',
  }
}, '/azienda/[slug]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, locale, preview, previewData }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina: paginaAzienda },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'azienda', preview, withMenuChildren: true },
      context: {
        headers,
      },
    })

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: slug, preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    return {
      props: { pagina, paginaAzienda },
      revalidate: 60 * 20,
    }
  },
  '/azienda/[slug]'
)

export default AziendaDetail
